const TRANSACTION_CREATE = '/transactions/create'

export type TradeCreateQuery = {
  tradeId?: string
  receiptTradeId?: string
  quickAdd?: string
  /** Which side of the deal a phone opens on (both show side by side on a wide screen). */
  side?: 'store' | 'customer'
}

/** The card scanner, scanning straight onto one side of this trade. */
export function tradeScanPath(tradeId: string, side: 'store' | 'customer'): string {
  return `/scanner?${new URLSearchParams({ tradeId, side }).toString()}`
}

/** Path for the in-store transaction builder (`/transactions/create`) with optional query. */
export function tradeCreatePath(query?: TradeCreateQuery): string {
  if (!query) return TRANSACTION_CREATE
  const params = new URLSearchParams()
  if (query.tradeId) params.set('tradeId', query.tradeId)
  if (query.receiptTradeId) params.set('receiptTradeId', query.receiptTradeId)
  if (query.quickAdd) params.set('quickAdd', query.quickAdd)
  if (query.side) params.set('side', query.side)
  const qs = params.toString()
  return qs ? `${TRANSACTION_CREATE}?${qs}` : TRANSACTION_CREATE
}
